import React, { useState, useEffect } from "react";

import { useNavigate } from "react-router-dom";

import {
  Stack,
  Input,
  InputLeftElement,
  InputGroup,
  IconButton,
  Spinner,
  Button,
  useDisclosure,
} from "@chakra-ui/react";

import EditUserModal from "./components/EditUserModal/EditUserModal";

import TablePagination from "components/TablePagination/TablePagination";

import { GetUsersList } from "services/UsersRequestService";
import formatDate from "utils/utils";

import edit_user_icon from "assets/images/icons/user_management_icons/edit_user_blue_icon.png";
import ActiveInactiveTags from "components/Tags/ActiveInactiveTags";
import UserRoleTags from "components/Tags/UserRoleTags";

import button_plus_icon from "assets/images/icons/button_plus_icon.png";

import ThemeColorConstant from "constants/ThemeColorsConstant";

import data_not_found_blue_icon from "assets/images/icons/general_icons/data_not_found_blue_icon.png";
import my_suppliers_search_icon from "assets/images/icons/my_suppliers_search_icon.svg";

export default function UserManagementView() {
  const navigate = useNavigate();

  const [currentPage, setCurrentPage] = useState(0);
  const [pageSize, setPageSize] = useState(10);
  const [totalPages, setTotalPages] = useState(0);
  const [totalRecords, setTotalRecords] = useState(0);

  const [searchTerm, setSearchTerm] = useState("");

  const [userList, setUserList] = useState([]);
  const [isLoading, setIsLoading] = useState(true);

  const [userDataEditModal, setUserDataEditModal] = useState({});

  const [checkUpdate, setCheckUpdate] = useState(false);

  const {
    isOpen: isOpenEditModal,
    onOpen: onOpenEditModal,
    onClose: onCloseEditModal,
  } = useDisclosure();

  const handleAddNewUser = () => {
    navigate("add_new_user");
  };

  useEffect(() => {
    // Reset the current page to 0 when the search term changes
    setCurrentPage(0);
  }, [searchTerm]);

  useEffect(() => {
    const fetchData = async () => {
      setIsLoading(true);
      try {
        let reqParams = {
          page_number: currentPage,
          page_size: pageSize,
          search: searchTerm,
        };

        const response = await GetUsersList(reqParams);

        setUserList(response?.data?.data);
        setTotalPages(response?.data?.pages);
        setTotalRecords(response?.data?.total_records);
      } catch (error) {
        console.log(error);
      } finally {
        setIsLoading(false);
      }
    };

    const debounce = setTimeout(() => {
      fetchData();
    }, 500);

    return () => clearTimeout(debounce);
  }, [searchTerm, checkUpdate, currentPage, pageSize]);

  const handleNavigationToUserDetail = (data) => {
    navigate(`user_details/${data.user_id}`, {
      state: { data: data },
    });
  };

  console.log(userList, "userList");

  return (
    <div>
      <Stack spacing={"35px"}>
        <EditUserModal
          isOpen={isOpenEditModal}
          onClose={onCloseEditModal}
          userDataProp={userDataEditModal}
          setCheckUpdate={setCheckUpdate}
        />
        <div>
          <div className="flex  flex-col max-md:gap-2 lg:flex-row justify-between">
            <h1 className="font-raleway  ">User Management</h1>
            <div className="w-[10rem]">
              <Button
                variant="solid"
                sx={{ bg: ThemeColorConstant.secondaryColor }}
                onClick={handleAddNewUser}
              >
                <img className="" src={button_plus_icon} />
                Add New User
              </Button>
            </div>
          </div>
        </div>
        <div className="flex flex-col  ">
          <div className="h-full border primary-border-color  ">
            <div className=" flex flex-row justify-between ">
              <div className="md:flex flex-col  w-80 mr-2 hidden  ">
                <InputGroup size="lg">
                  <InputLeftElement
                    sx={{ paddingTop: "25px" }}
                    pointerEvents="none"
                  >
                    <img src={my_suppliers_search_icon} />
                  </InputLeftElement>
                  <Input
                    variant="unstyled"
                    placeholder="Search User with Name or Email"
                    value={searchTerm}
                    onChange={(e) => setSearchTerm(e.target.value)}
                    sx={{
                      width: "100%",
                      fontSize: { base: "16px", sm: "12px", xs: "10px" },
                      fontcolor: "#00000099",
                    }}
                  />
                </InputGroup>
              </div>
              {/* <div className="flex lg:hidden  flex-col justify-center mr-2  ">
                <IconButton
                  variant="ghost"
                  icon={<img src={dot_verticle_icon} />}
                  sx={{
                    width: "40px",
                    height: "40px",
                    justifyContent: "center",
                  }}
                  onClick={onOpen}
                />
              </div> */}

              <div className="flex flex-row gap-5 max-lg:hidden">
                {/* <div className="flex flex-col justify-center table-heading ">
                  <div>Sort By</div>
                  <div>Last Updated</div>
                </div> */}
                {/* <div className="w-40 flex flex-col justify-center mr-2  ">
                  <Select
                    size="lg"
                    variant="outlineCustom"
                    onChange={(e) => setSortByLastUpdated(e.target.value)}
                    value={sortByLastUpdated}
                  >
                    {sort_last_updated_selector_data?.map((data, index) => {
                      return (
                        <option key={index} value={data.value}>
                          {data.label}
                        </option>
                      );
                    })}
                  </Select>
                </div> */}
              </div>
            </div>
          </div>

          {isLoading && (
            <div className="flex flex-row justify-center   h-[34rem] ">
              <Spinner className="my-auto" size="xl" />
            </div>
          )}

          <div className="overflow-x-auto   max-h-[37rem]  overflow-y-auto  ">
            {!isLoading && (
              <>
                <table className=" w-full  border border-[#e9e9e9] table-auto">
                  <thead>
                    <tr className="bg-[#e9e9e9] h-[2.63rem]">
                      <th className="pl-4 py-1.5  ">
                        <p className="table-heading">Name</p>
                      </th>
                      <th className="py-1.5 table-heading  max-w-60 xl:max-w-xl">
                        Email
                      </th>
                      <th className="py-1.5 table-heading">Date Created</th>
                      <th className="py-1.5 table-heading">Role</th>
                      <th className="py-1.5 table-heading-center">Status</th>
                      <th className="py-1.5 table-heading-center">Action</th>
                    </tr>
                  </thead>
                  <tbody className="">
                    {userList?.map((data, index) => {
                      return (
                        <tr
                          className="border-x primary-border-color hover:bg-gray-100 hover:cursor-pointer group h-[3.13rem] "
                          onClick={(e) => handleNavigationToUserDetail(data)}
                          key={index}
                        >
                          <td className="pl-2 py-2.5 max-w-xs truncate   group-hover:underline h-full ">
                            <p className="table-text">
                              {data?.first_name} {data?.last_name}
                            </p>
                          </td>
                          <td className="table-text-light truncate  max-w-60 xl:max-w-xl">
                            {data.user_email}
                          </td>
                          <td className="table-text-light  ">
                            {formatDate(data.created_on)}
                          </td>
                          <td className="">
                            {data?.user_has_role.length > 0 ? (
                              <UserRoleTags
                                role={
                                  data.user_has_role[0]?.user_role_id
                                    ?.user_role_name
                                }
                              />
                            ) : (
                              <UserRoleTags role={"None"} />
                            )}
                          </td>
                          <td className="text-center">
                            <ActiveInactiveTags
                              is_active={data?.user_is_active}
                            />
                          </td>
                          <td className="text-center">
                            <div className="flex flex-row justify-center">
                              <IconButton
                                variant="ghost"
                                icon={<img src={edit_user_icon} />}
                                onClick={(e) => {
                                  e.stopPropagation();
                                  setUserDataEditModal(data);
                                  onOpenEditModal();
                                }}
                              />
                            </div>
                          </td>
                        </tr>
                      );
                    })}
                  </tbody>
                </table>
                {!userList?.length && !isLoading && (
                  <div className="flex flex-row justify-center h-[32rem]    ">
                    <div className="my-auto flex flex-row justify-center gap-2 ">
                      <img
                        src={data_not_found_blue_icon}
                        alt="data not found icon"
                      />
                      <p>Data Not Found</p>
                    </div>
                  </div>
                )}
                <TablePagination
                  pageSize={pageSize}
                  setPageSize={setPageSize}
                  totalRecords={totalRecords}
                  totalPages={totalPages}
                  currentPage={currentPage}
                  setCurrentPage={setCurrentPage}
                />
              </>
            )}
          </div>
        </div>
      </Stack>
    </div>
  );
}
